import React from 'react'
import styled from 'react-emotion'
import Link from 'gatsby-link'
import logoImage from './logo.png'

const HomeLink = styled(Link)`
  display: inline-block;
`

const Image = styled.img`
  margin: 0;
`

const Logo = () => (
  <HomeLink to="/">
    <Image src={logoImage} alt="ChouxBox" />
  </HomeLink>
)

export default Logo



// WEBPACK FOOTER //
// ./src/components/NavBar/Logo/index.js